import { Card, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import staticData from '../staticData';

const Main = () => {
    return (
        <Box sx={{ minHeight: '70vh' }}>
            <Grid container spacing={3}>
                {staticData.map((item) => (
                    <Grid item xs={12}>
                        <Link
                            to={`/video/${item.id}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <Card
                                sx={{
                                    px: 3,
                                    py: 2,
                                    display: 'flex',
                                    gap: 3,
                                    cursor: 'pointer',
                                }}
                            >
                                <Box
                                    component={'img'}
                                    width={300}
                                    height={1}
                                    boxShadow={1}
                                    src={item.image}
                                    borderRadius={8}
                                    sx={{
                                        objectFit: 'cover',
                                    }}
                                ></Box>
                                <Typography
                                    variant="h4"
                                    sx={{ fontWeight: '500' }}
                                >
                                    {item.title}
                                </Typography>
                            </Card>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Main;
